import { create } from 'zustand';

interface Toast {
  id: string;
  message: string;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
  showToast: (message: string, duration?: number) => void;
  removeToast: (id: string) => void;
}

export const useToastStore = create<ToastState>(set => ({
  toasts: [],
  showToast: (message, duration = 3000) => {
    const id = Date.now().toString();
    let isAdded = false;

    set(state => {
      // 동일한 메시지의 토스트가 이미 있으면 중복으로 띄우지 않고 기존 상태 유지
      const isDuplicate = state.toasts.some(t => t.message === message);
      if (isDuplicate) {
        return state;
      }
      isAdded = true;
      return {
        toasts: [...state.toasts, { id, message, duration }],
      };
    });

    // 실제로 추가되었고 duration이 0보다 클 때만 자동 삭제 예약
    if (isAdded && duration > 0) {
      setTimeout(() => {
        set(state => ({
          toasts: state.toasts.filter(t => t.id !== id),
        }));
      }, duration);
    }
  },
  removeToast: id =>
    set(state => ({
      toasts: state.toasts.filter(t => t.id !== id),
    })),
}));
